import Switch from 'components/Switch';
import { FC, Fragment, useCallback, useRef, useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from 'components/ui/card';
import { IPrivacy } from '../ListItems/ListItems';

interface IItemProps {
  privacyDate: IPrivacy;
  index: number;
  opened: boolean;
  onToggleHandler: (index: number) => void;
}

const Item: FC<IItemProps> = ({
  index,
  privacyDate,
  onToggleHandler,
  opened,
}) => {
  const [openedItem, setOpenedItem] = useState<boolean>(false);
  const cardRef = useRef<HTMLDivElement>(null);

  const onChangeSwitch = useCallback(() => {
    onToggleHandler(index);
    if (privacyDate.opened !== openedItem) {
      setOpenedItem(true);
    } else {
      setOpenedItem((prevState) => (prevState = !opened));
    }
  }, [opened, openedItem]);

  useEffect(() => {
    if (privacyDate.opened && openedItem && cardRef.current) {
      setTimeout(() => {
        cardRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 100);
    }
  }, [privacyDate.opened, openedItem]);

  return (
    <Card ref={cardRef} className="mb-4">
      <CardHeader className="flex flex-row items-start sm:items-center justify-between gap-3 p-4">
        <CardTitle className="flex items-start gap-2 text-base font-medium flex-1 min-w-0 pr-2">
          <span className="flex-shrink-0">
            {index !== 0 ? `${index}.` : null}
          </span>
          <span className="flex-1">{privacyDate.title}</span>
        </CardTitle>
        <div className="flex-shrink-0 self-start pt-0.5">
          <Switch
            checked={openedItem && privacyDate.opened}
            onChange={onChangeSwitch}
          />
        </div>
      </CardHeader>
      {privacyDate.opened && openedItem && (
        <CardContent className="pt-0">
          {privacyDate.subtitleLists.map(({ subtitle, text, paragraph }, i) => (
            <div key={i} className="mb-4">
              {!!paragraph ? (
                <>
                  <div className="font-semibold mb-2">{paragraph.subtitle}</div>
                  <ul className="list-disc pl-6">
                    {paragraph.items.map((item, idx) => (
                      <li key={idx} className="mb-1 text-sm">
                        {item}
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <>
                  <div className="font-semibold mb-2">{subtitle}</div>
                  <div className="text-sm">{text}</div>
                </>
              )}
            </div>
          ))}
        </CardContent>
      )}
    </Card>
  );
};

export default Item;
